import React from "react";

export default function LegalPageLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="container py-16 max-w-3xl" data-testid="legal-page">
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h1 className="display-1 mb-2">{title}</h1>
      {updated && <p className="text-sm text-muted-foreground mb-10">Last updated {updated}</p>}
      <div className="space-y-8">{children}</div>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="text-xl font-semibold text-foreground mb-3">{heading}</h2>
      <div className="text-muted-foreground leading-relaxed space-y-3">{children}</div>
    </section>
  );
}
